import './Timestamp.css';
import { useState } from 'react';

function Timestamp() {
  const now = new Date().toLocaleString();
  const [videoUrl, setVideoUrl] = useState('https://www.youtube.com/watch?v=sWHMIjgcxEU');
  const [videoInfo, setVideoInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchVideoInfo = async () => {
    if (!videoUrl.trim()) {
      setError('Please enter a valid YouTube URL');
      return;
    }

    setLoading(true);
    setError(null);
    setVideoInfo(null);

    try {
      // Determine API base URL based on environment
      let apiBaseUrl;
      
      if (process.env.NODE_ENV === 'development') {
        // Local development: using local functions emulator
        apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
      } else {
        // Production: using Firebase Cloud Functions
        apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 
                     'https://us-central1-my-react-app-94fc1.cloudfunctions.net';
      }
      
      const endpoint = `${apiBaseUrl}/api/video-info?url=${encodeURIComponent(videoUrl)}`;
      
      console.log('Fetching from:', endpoint);
      const response = await fetch(endpoint);

      if (!response.ok) {
        throw new Error(`Failed to fetch video information: ${response.status}`);
      }

      const data = await response.json();
      setVideoInfo(data);
      console.log('Video data received:', data);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching video info:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="timestamp">
      <div className="timestamp__time">
        <span className="timestamp__label">Current time:</span>
        <span className="timestamp__value">{now}</span>
      </div>

      <div className="timestamp__video-section">
        <div className="timestamp__input-group">
          <input
            type="text"
            value={videoUrl}
            onChange={(e) => setVideoUrl(e.target.value)}
            placeholder="Paste YouTube URL here..."
            className="timestamp__input"
          />
          <button 
            onClick={fetchVideoInfo} 
            disabled={loading}
            className="timestamp__button"
          >
            {loading ? 'Loading...' : 'Generate Timestamps'}
          </button>
        </div>

        {error && (
          <div className="timestamp__error">
            Error: {error}
          </div>
        )}

        {videoInfo && (
          <div className="timestamp__video-info">
            {videoInfo.thumbnail && (
              <div className="timestamp__thumbnail">
                <img 
                  src={videoInfo.thumbnail} 
                  alt={videoInfo.title}
                  className="timestamp__image"
                />
              </div>
            )}

            <div className="timestamp__details">
              <h3 className="timestamp__title">{videoInfo.title}</h3>
              
              <div className="timestamp__meta">
                <p><strong>Creator:</strong> {videoInfo.creator}</p>
                <p><strong>Channel:</strong> {videoInfo.channel}</p>
                <p><strong>Duration:</strong> {videoInfo.duration_formatted}</p>
                <p><strong>Upload Date:</strong> {videoInfo.upload_date}</p>
                <p><strong>Video Age:</strong> {videoInfo.age_days.formatted}</p>
                <p><strong>Views:</strong> {videoInfo.view_count?.toLocaleString() || 'N/A'}</p>
                <p><strong>Likes:</strong> {videoInfo.like_count?.toLocaleString() || 'N/A'}</p>
                <p><strong>Comments:</strong> {videoInfo.comment_count?.toLocaleString() || 'N/A'}</p>
              </div>

              {videoInfo.description && (
                <div className="timestamp__description">
                  <p><strong>Description:</strong></p>
                  <p>{videoInfo.description.substring(0, 200)}...</p>
                </div>
              )}

              {videoInfo.tags && videoInfo.tags.length > 0 && (
                <div className="timestamp__tags">
                  <strong>Tags:</strong>
                  <div className="timestamp__tag-list">
                    {videoInfo.tags.map((tag, idx) => (
                      <span key={idx} className="timestamp__tag">{tag}</span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Timestamp;
